import { types } from 'mobx-state-tree';

const MenuPosition = {
  PRIMARY: 'PRIMARY',
  CHECKOUT: 'CHECKOUT',
  PROPOSAL_REQUEST: 'PROPOSAL_REQUEST',
};

export default MenuPosition;

export const MenuPositionType = types.enumeration(
  'MenuPositionType',
  Object.values(MenuPosition)
);
